export default {
  UPDATE_COMPANYINFO (state, companyInfo) {
    state.currentCompanyInfo = companyInfo;
  },
};
